// OWNER: tracking agent. Typed calls for /api/tracking (SPEC §19, 2026-10-01; contract in src/shared/api-tracking.ts).
import { api } from '../api';
import type { LiveBoard, Scoreboard, SetterTargets, TargetsSetting, TimelineEvent } from '../../../src/shared/api-tracking';

const qs = (o: Record<string, string | number | undefined | null>): string => {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(o)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const trackingApi = {
  scoreboard: (q: { from: string; to: string; userId?: number; campaignId?: number }) => api.get<Scoreboard>(`/api/tracking/scoreboard${qs(q)}`),
  live: () => api.get<LiveBoard>('/api/tracking/live'),
  timeline: (q: { userId?: number; day: string }) => api.get<TimelineEvent[]>(`/api/tracking/timeline${qs(q)}`),
  targets: () => api.get<TargetsSetting | { effective: SetterTargets }>('/api/tracking/targets'),
  saveTargets: (t: TargetsSetting) => api.put<TargetsSetting>('/api/tracking/targets', t),
  /** A plain link (the browser downloads it with the session cookie; GET needs no CSRF header). */
  callsCsvUrl: (q: { from: string; to: string; userId?: number; campaignId?: number }) => `/api/tracking/calls.csv${qs(q)}`,
};
